import { render, staticRenderFns } from "./reader.vue?vue&type=template&id=00d74780"
import script from "./reader.vue?vue&type=script&lang=js"
export * from "./reader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports